import { AchievementCondition } from "../goal_templates/classes/achievement_conditions_class";
import { User } from "../goal_templates/classes/current_user_class";
import { OccurrenceFrequencyLevel } from "../goal_templates/classes/dates/occurrence_frequency";
import { GoalType } from "../goal_templates/classes/goal_type_class";
import { EducationGoalTemplate } from "../goal_templates/classes/goal_template_education_class";
import { InterviewGoalTemplate } from "../goal_templates/classes/goal_template_interview_class";
import { ObservationGoalTemplate } from "../goal_templates/classes/goal_template_observation_class";
import { Measurement } from "../goal_templates/classes/measurements/measurement";
import { MeasurementUnit } from "../goal_templates/classes/measurements/measurement_unit_class";
import {
  MeasurementShape,
  MeasurementUnitShape,
} from "../goal_templates/interfaces/classTypes";

import { PatientGoalType } from "../goal_templates/classes/patient_goal_type_class";
import { PatientGoalInterview } from "../goal_templates/classes/patient_goal_interview_class";
import { PatientGoalEducation } from "../goal_templates/classes/patient_goal_education_class";
import { PatientGoalObservation } from "../goal_templates/classes/patient_goal_observation_class";
import { GoalHistoryBlock } from "../goal_templates/classes/goal_history_block_class";
import { MonitorProgramPreview } from "../goal_templates/classes/monitor_program_preview_class";
import { NewInterview } from "../goal_templates/classes/new_interview_class";
import { InterviewSet } from "../goal_templates/classes/interview_set_class";

export class SetupHandler {
  public payload: any;
  public setDBObject: any;
  public loadComplete: boolean;

  constructor(payload, setDBObject) {
    var setupState = {};
    var currentUser = new User(payload.user);
    setupState["User"] = currentUser;

    var measurementUnitPayload = payload.measurementUnits.map(
      (unit: MeasurementUnitShape) => new MeasurementUnit(unit)
    );
    setupState["MeasurementUnit"] = measurementUnitPayload;

    var measurementPayload = payload.measurements.map(
      (measurement: MeasurementShape) => new Measurement(measurement)
    );
    setupState["Measurement"] = measurementPayload;

    setupState["indexTableHeaders"] = payload.indexTableHeaders;

    setupState["templateTableHeaders"] = payload.templateTableHeaders;

    var occurrenceFrequencySet = payload.occurrenceFrequencies.map(
      (frequency) => new OccurrenceFrequencyLevel(frequency)
    );
    setupState["OccurrenceFrequencyLevel"] = occurrenceFrequencySet;

    var achievementConditionsSet = payload.achievementConditions.map(
      (condition) => new AchievementCondition(condition)
    );
    setupState["AchievementCondition"] = achievementConditionsSet;

    if (payload.goalTypes) {
      var goalTypeSet = payload.goalTypes.map((type) => new GoalType(type));
      setupState["GoalType"] = goalTypeSet;
    }

    if (payload.patientGoalTypes) {
      var patientGoalTypeSet = payload.patientGoalTypes.map(
        (category) => new PatientGoalType(category)
      );
      setupState["PatientGoalType"] = patientGoalTypeSet;
    }

    if (payload.interviewSets) {
      var InterviewSetPayload = payload.interviewSets.map((interviewSet) => {
        return new InterviewSet(interviewSet);
      });
      setupState["InterviewSets"] = InterviewSetPayload;
    }

    if (payload.monitorPrograms) {
      var programSet = [];
      payload.monitorPrograms.forEach((program) => {
        programSet.push(new MonitorProgramPreview(program));
      });
      setupState["MonitorPrograms"] = programSet;
    }

    if (payload.measurementsWithZeroValueInitialReading) {
      setupState["zeroValueInitialReadingMeasurements"] =
        payload.measurementsWithZeroValueInitialReading;
    }
    setDBObject(setupState);
  }
}

export class TemplateHandler {
  public payload: any;
  constructor(templates) {
    var goalTemplateSet = templates.map((template) => {
      switch (template.type) {
        case "GoalTemplateInterview":
          return new InterviewGoalTemplate(template);
          break;
        case "GoalTemplateEducation":
          return new EducationGoalTemplate(template);
          break;
        case "GoalTemplateObservation":
          return new ObservationGoalTemplate(template);
          break;
        default:
          console.log("check your goal templates.");
          break;
      }
    });
    return goalTemplateSet;
  }
}

export class PatientGoalPreviewHandler {
  constructor(goalPayload) {
    var goalPreview;
    switch (goalPayload.type) {
      case "PatientGoalInterview":
        goalPreview = new PatientGoalInterview(goalPayload);
        break;
      case "PatientGoalEducation":
        goalPreview = new PatientGoalEducation(goalPayload);
        break;
      case "PatientGoalObservation":
        goalPreview = new PatientGoalObservation(goalPayload);
        break;
      default:
        console.log("check your patient goal type!");
    }
    return goalPreview;
  }
}

export class PatientGoalSetHandler {
  constructor(goalPayload, setSelectedPatientGoals) {
    var goalSet = [];
    goalPayload.map((goalData) => {
      switch (goalData.type) {
        case "PatientGoalInterview":
          goalSet.push(new PatientGoalInterview(goalData));
          break;
        case "PatientGoalEducation":
          goalSet.push(new PatientGoalEducation(goalData));
          break;
        case "PatientGoalObservation":
          goalSet.push(new PatientGoalObservation(goalData));
          break;
        default:
          console.log("check your patient goal type!");
      }
    });
    setSelectedPatientGoals(goalSet);
  }
}

export class GoalHistoriesHandler {
  constructor(payload, action) {
    var historySet = [];
    payload.forEach((goalBlock) => {
      historySet.push(new GoalHistoryBlock(goalBlock));
    });
    action(historySet);
  }
}

export class MonitorProgramHandler {
  constructor(payload, setDBObject) {
    var programSet = [];
    payload.forEach((program) => {
      programSet.push(new MonitorProgramPreview(program));
    });
    setDBObject({ MonitorPrograms: programSet });
  }
}
